import React, { FC } from 'react';

type Props = {
  message: string;
}

export const NoContent: FC<Props> = ({message}) => {
  return (
    <div>
      <div className="d-flex justify-content-center align-item-center">
        <div className="text-center pt-20 pb-20">
          <i className="bi bi-folder" style={{ fontSize: "3.5em" }}></i>
          <p className="text-muted ms-20p me-20p pt-3 pb-3">
            {message}
          </p>
        </div>
      </div>
    </div>
  );
};
